import React, { useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { useSmartEntity } from 'contexts/smart-entity'
import { getListRepresentationFromProfile } from 'utilities/person'
import Fieldset from 'components/form/fieldset'
import Paragraph from 'components/typography/paragraph'
import PersonField from 'components/form/field/person'
import EntityField from 'components/form/field/entity'

const Sources = ({ salt }) => {
    const { getCustomSources } = useSmartEntity()

    const sources = getCustomSources()
    if(!sources.length) {
        return null
    }

    return (
        <Fieldset>
            <Paragraph className="caption small">
                <FormattedMessage
                    id="documents_smart_create_predefined_data_sources_helper"
                    defaultMessage="{count, plural, =0 {} =1 {This template has a predefined data source. You can assign who or what it should be now, or leave it for another time.} other {This template has {count} predefined data sources. You can assign who or what they should be now, or leave it for another time.}}"
                    values={{ count: sources.length }} />
            </Paragraph>
            {sources.map(source => (
                <SourceField
                    {...source}
                    salt={salt}
                    key={`${salt}:data-source:${source.type}.${source.name}`} />
            ))}
        </Fieldset>
    )
}

const SourceField = ({ type, name, label, salt }) => {
    const {
        values,
        setValue
    } = useSmartEntity()

    const [hasInteracted, setHasInteracted] = useState(false)

    const key = `${type}.${name}`

    const [Field, props = null] = ({
        user: [PersonField],
        team: [EntityField, getEntityFieldProps('team')],
        location: [EntityField, getEntityFieldProps('location')]
    })[type]

    let value = values?.[key]?.value ?? null
    if(type === 'user' && !!value) {
        value = getListRepresentationFromProfile(value)
    }

    return (
        <Field
            {...props}
            salt={salt}
            className="vertical"
            label={label}
            name={key}
            field={{
                value,
                include: 'never'
            }}
            onToggle={() => setHasInteracted(true)}
            onChange={({ [key]: value }) => {
                if(!hasInteracted) {
                    return
                }

                setValue({ key, type, name, value })
            }}
         />
    )
}

const getEntityFieldProps = type => ({
    entity: {
        type,
        path: '/groups',
        params: { types: [type] }
    }
})

export default Sources